export const NIGERIAN_STATES = [
  "Abia",
  "Adamawa",
  "Akwa Ibom",
  "Anambra",
  "Bauchi",
  "Bayelsa",
  "Benue",
  "Borno",
  "Cross River",
  "Delta",
  "Ebonyi",
  "Edo",
  "Ekiti",
  "Enugu",
  "FCT",
  "Gombe",
  "Imo",
  "Jigawa",
  "Kaduna",
  "Kano",
  "Katsina",
  "Kebbi",
  "Kogi",
  "Kwara",
  "Lagos",
  "Nasarawa",
  "Niger",
  "Ogun",
  "Ondo",
  "Osun",
  "Oyo",
  "Plateau",
  "Rivers",
  "Sokoto",
  "Taraba",
  "Yobe",
  "Zamfara",
];

export const BUSINESS_TYPES = [
  "Sole proprietorship",
  "Partnership",
  "Limited liability company (LLC)",
  "Registered business name",
  "Online / informal seller",
];

export const BUSINESS_CATEGORIES = [
  "Fashion & apparel",
  "Electronics",
  "Phones & tablets",
  "Groceries & supermarket",
  "Health & beauty",
  "Home & kitchen",
  "Baby, kids & toys",
  "Sporting goods",
  "Building materials",
  "Other",
];

export const MOBILE_MONEY_PROVIDERS = ["OPay", "PalmPay", "MTN MoMo", "Airtel Money", "Moniepoint", "Kuda"];

export const FIELD_LIMITS = {
  short: 120,
  medium: 500,
  long: 2000,
};

/** Fields saved from the business profile form — payout/bank is on the Payments page. */
export const BUSINESS_SAVE_FIELDS = [
  "businessName",
  "businessType",
  "businessCategory",
  "businessAddress",
  "city",
  "state",
  "contactPerson",
  "contactEmail",
  "contactPhoneNumber",
  "businessDescription",
  "taxIdentificationNumber",
  "businessLicenseOrPermit",
  "valueAddedTaxRegistration",
  "goodsAndServicesTaxRegistration",
  "businessRegistrationNumber",
  "customsIdentificationNumber",
  "productInformation",
  "returnsAndRefundsPolicy",
  "customerSupportInformation",
];

export const EMPTY_BUSINESS_FORM = BUSINESS_SAVE_FIELDS.reduce(
  (acc, key) => ({ ...acc, [key]: "" }),
  {}
);

export const merchantToForm = (merchant, user) => ({
  ...EMPTY_BUSINESS_FORM,
  businessName: merchant?.businessName || "",
  businessType: merchant?.businessType || "",
  businessCategory: merchant?.businessCategory || "",
  businessAddress: merchant?.businessAddress || "",
  city: merchant?.city || "",
  state: merchant?.state || "",
  contactPerson: merchant?.contactPerson || `${user?.first_name || ""} ${user?.last_name || ""}`.trim(),
  contactEmail: merchant?.contactEmail || user?.email || "",
  contactPhoneNumber: merchant?.contactPhoneNumber || user?.phone_number || "",
  businessDescription: merchant?.businessDescription || "",
  taxIdentificationNumber: merchant?.taxIdentificationNumber || "",
  businessLicenseOrPermit: merchant?.businessLicenseOrPermit || "",
  valueAddedTaxRegistration: merchant?.valueAddedTaxRegistration || "",
  goodsAndServicesTaxRegistration: merchant?.goodsAndServicesTaxRegistration || "",
  businessRegistrationNumber: merchant?.businessRegistrationNumber || "",
  customsIdentificationNumber: merchant?.customsIdentificationNumber || "",
  productInformation: merchant?.productInformation || "",
  returnsAndRefundsPolicy: merchant?.returnsAndRefundsPolicy || "",
  customerSupportInformation: merchant?.customerSupportInformation || "",
});

export const buildBusinessSavePayload = (formData) => {
  const payload = {};
  for (const key of BUSINESS_SAVE_FIELDS) {
    payload[key] = String(formData?.[key] ?? "").trim();
  }
  return payload;
};

export const buildMobileMoneyPayload = (provider, number) => ({
  payoutMethod: "mobile_money",
  mobileMoneyProvider: String(provider || "").trim(),
  mobileMoneyNumber: String(number || "").trim(),
});
